<app-company-edit-form (onSubmit)="submit($event)" [isSupplier]="isSupplier" [isDialog]="dialogData"
  [datatableContainerFilterValues]="datatableContainerFilterValues" [parentComponent]="this"></app-company-edit-form>

<ng-container *ngIf="enableMasterDetail">

  <div class="ct-manager-master-detail-container">

    <app-company-information #companyInformationComponent [masterConfiguration]="companyModelConfiguration" [parentComponent]="this"></app-company-information>

  </div>

  <div class="ct-manager-master-detail-container">

    <app-company-place-list #companyPlaceListComponent [masterConfiguration]="companyModelConfiguration" [parentComponent]="this"></app-company-place-list>

  </div>

  <div class="ct-manager-master-detail-container" *ngIf="!isSupplier && this.leadCompanyConfiguration.visible">

    <app-company-lead [companyModelConfiguration]="companyModelConfiguration"></app-company-lead>

  </div>

  <div class="ct-manager-master-detail-container" *ngIf="!isSupplier">

    <app-company-contract [masterConfiguration]="companyModelConfiguration"></app-company-contract>

  </div>

  <div class="ct-manager-master-detail-container">

    <app-company-contact *ngIf="companyContactModelConfiguration && this.contactCompanyConfiguration.visible" [configuration]="companyContactModelConfiguration"
      [title]="'company.references'"></app-company-contact>

  </div>

  <div *ngIf="schedulerListConfiguration && calendarVisible" class="ct-manager-master-detail-container">

    <app-scheduler-list [schedulerListConfiguration]="schedulerListConfiguration"></app-scheduler-list>

  </div>

</ng-container>
